<template>
  <div>
    <Select
      :placeholder="$t('global.kiezen')"
      filterable
      clearable
      :disabled="checkIfCompetitionStarted"
    >
      <Option value="">{{ $t("global.kiezen") }}</Option>
      <Option
        v-for="license in licenseFilter()"
        :value="license._id"
        :disabled="true"
        :key="license._id"
        class="disabled-referee"
      >
        <div
          class="d-flex align-items-center justify-content-between"
          style="100%"
        >
          <span
            class="d-flex align-items-center justify-content-between w-100 position-relative"
          >
            <b>{{ license.firstName }} {{ license.secondName }}</b>
            <Poptip
              v-if="checkMedicalControl(license)"
              trigger="hover"
              transfer
              class="mr-2"
            >
              <Icon type="md-alert" color="red" size="20" />
              <div slot="content">
                <Alert class="medical-control-style" type="error"
                  >{{ $t("user.medical_control") }}
                </Alert>
              </div>
            </Poptip>
          </span>
          <Button
            @click="() => addPlayer(license._id)"
            type="success"
            icon="md-add"
            :disabled="
              checkIfCompetitionStarted || checkMedicalControl(license)
            "
          ></Button>
        </div>
      </Option>
    </Select>
  </div>
</template>

<script>
export default {
  name: "PlayerSelector",
  props: [
    "checkIfCompetitionStarted",
    "licenseFilter",
    "checkMedicalControl",
    "addPlayer",
    "special"
  ],
  mounted() {
    console.log({ comp: this.checkIfCompetitionStarted });
  }
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// src/components/team/PlayerSelector.vue